import React, { memo, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from '@widergy/web-utils/lib/array';
import { func } from 'prop-types';

import { actionCreators as accountActions } from 'redux/accountHandlers';
import { accountAlertTypes, accountTypes } from 'types/accountTypes';
import { useScreenSize } from 'utils/hooks';

import AlertCard from './components/AlertCard';
import styles from './styles.module.scss';
import { alertFlavours } from './constants';

const AlertsBar = ({ alerts, currentAccount, dispatch, handleUpdateAlertSize }) => {
  const { screenSize } = useScreenSize();

  const handleRecomputeHeight = useCallback(() => {
    const alertsBar = document.getElementById('alertsBar');
    const { height } = (alertsBar && alertsBar.getBoundingClientRect()) || {};
    handleUpdateAlertSize(height);
  }, [handleUpdateAlertSize]);

  useEffect(() => {
    dispatch(accountActions.getAccountAlerts(currentAccount.id));
  }, [dispatch, currentAccount.id]);

  useEffect(() => {
    setTimeout(handleRecomputeHeight, 350);
  }, [alerts, screenSize, handleRecomputeHeight]);

  const handleDeleteAlert = async () => {
    await dispatch(accountActions.closeAccountAlerts());
    handleRecomputeHeight();
  };

  const alert = !isEmpty(alerts) && alerts[0];

  return (
    <div
      id="alertsBar"
      className={`${styles.alertsBar} ${!alert && styles.hidden} ${styles[alert.category]}`}
    >
      {alert && (
        <AlertCard
          title={alert.title}
          content={alert.message}
          onClose={handleDeleteAlert}
          {...(alertFlavours[alert.category] || {})}
        />
      )}
    </div>
  );
};

AlertsBar.propTypes = {
  alerts: accountAlertTypes,
  handleUpdateAlertSize: func,
  currentAccount: accountTypes
};

const mapStateToProps = store => ({
  alerts: store.account.alerts,
  currentAccount: store.account.currentAccount
});

export default connect(mapStateToProps)(memo(AlertsBar));
